import { render, staticRenderFns } from "./approval-info-dialog.vue?vue&type=template&id=1181f5c6&scoped=true"
import script from "./approval-info-dialog.vue?vue&type=script&lang=js"
export * from "./approval-info-dialog.vue?vue&type=script&lang=js"
import style0 from "./approval-info-dialog.vue?vue&type=style&index=0&id=1181f5c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1181f5c6",
  null
  
)

export default component.exports